import { getMessaging } from "firebase/messaging";

import useArePushNotificationsSupported from "services/firebase/messaging/hooks/useArePushNotificationsSupported";

export default function useGetMessaging() {
  const isPushSupported = useArePushNotificationsSupported();
  if (isPushSupported) return getMessaging();
}
